/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon20Solid = forwardRef('DataChartPieA2Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.25 2.035a8 8 0 1 0 8.715 8.715H10.75a1.5 1.5 0 0 1-1.5-1.5V2.035Z" }),
        React.createElement("path", { d: "M10.75 2.035a8.002 8.002 0 0 1 7.215 7.215H10.75V2.035Z" })));
});
